var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-homepage-course": "" } }, [
    _c(
      "div",
      {
        staticClass:
          "row p-4 text-center justify-content-around align-items-center"
      },
      [
        _c("h2", { staticClass: "col-12 mb-5 font-italic" }, [
          _vm._v(_vm._s(_vm.T.courseHomepageTitle))
        ]),
        _c(
          "a",
          {
            staticClass:
              "col-xs-6 col-sm-3 btn btn-primary btn-lg mx-auto custom-button",
            attrs: { role: "button", href: "/course/" }
          },
          [_vm._v(_vm._s(_vm.T.wordsGetToKnowOurCourses))]
        )
      ]
    ),
    _c("div", { staticClass: "dropdown-divider" }),
    _c("div", { staticClass: "container-lg" }, [
      _c(
        "div",
        {
          staticClass:
            "row p-4 text-center text-md-left justify-content-around align-items-center"
        },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-md-6 mt-2 mt-md-0" },
            [
              _c("omegaup-markdown", {
                attrs: { markdown: _vm.T.courseHomepageTeachersSectionContent }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "row p-4 text-center text-md-left justify-content-around align-items-center"
        },
        [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "col-md-6 mt-2 mt-md-0" },
            [
              _c("omegaup-markdown", {
                attrs: { markdown: _vm.T.courseHomepageStudentsSectionContent }
              })
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-3 col-md-5 mt-2 mt-md-0" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/media/course_homepage/teachers_section.svg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-3 col-md-5 order-md-2 mt-2 mt-md-0" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/media/course_homepage/students_section.svg" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }